export * from './feedback/feedback.component';
